export * from "./assets";
export * from "./camera";
export * from "./project";

export const asyncTimeout = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};